import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Response } from '@shared/interfaces/response/response';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SubEstatusService {

  constructor(private http : HttpClient) { }
  ExecCmspaSubestatus(model : any) : Observable<Response>{
    return this.http.post<Response>(environment.apiBaseUrl + "api/CmspaSubestatus/ExecCmspaSubestatus",model);
  }

  getSubEstatusList(model: any): Observable<Response> {
    return this.http.post<Response>(environment.apiNewBackBaseUrl + "SubEstatus/cmspa_subestatusList", model);
  }

  addSubEstatus(model: any): Observable<Response> {
    return this.http.post<Response>(environment.apiNewBackBaseUrl + "SubEstatus/cmspa_subestatusAd", model);
  }

  updateSubEstatus(model: any): Observable<Response> {
    return this.http.post<Response>(environment.apiNewBackBaseUrl + "SubEstatus/cmspa_subestatusUpd", model);
  }

  deleteSubEstatus(model: any): Observable<Response> {
    return this.http.post<Response>(environment.apiNewBackBaseUrl + "SubEstatus/cmspa_subestatusDel", model);
  }
}
